import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Typography from "material-ui/Typography";
import moment from "moment";
import LineChartViewer from '../next/line'
import PairSelector from '../../components/pairSelector'
import PairResultsViewer from '../../components/pairResults'
import CustomTooltip from '../next/components/tooltip'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { pairColor } from '../../paircolors'

class QtRfResult extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      displayPairResults: 4,
      displayResults: 8,
      height: 300,
      pairs: null,
      selectedPairs: null,
      allPairs: true,
      fullView: false,
      combined: false,
      combinedSelectedPairs: null
    }
  }

  resetCurrentState = () => {
    this.setState({
      displayPairResults: 4,
      displayResults: 8,
      height: 300,
      pairs: null,
      selectedPairs: null,
      allPairs: true,
      fullView: false,
      combined: false,
      combinedSelectedPairs: null
    });
    this.props.resetResultsState();
  }

  updatePairsInfo = (pairs, iscombined) => {
    let tempKey = 0
    let { selectedPairs, combinedSelectedPairs, allPairs } = this.state

    if(!selectedPairs) {
      selectedPairs = pairs.map((pair, key) => {
        tempKey++
        return {
          key,
          value: pair,
          checked: true,
          stroke: pairColor(pair)
        }
      })
    }

    if (iscombined) {
      if(!combinedSelectedPairs) {
      combinedSelectedPairs = pairs.map((pair, key) => {
        return {
          key,
          value: pair,
          checked: true,
          stroke: pairColor(pair),
          tempKey
        }
      })
    }
  }

  this.setState({
      pairs: pairs,
      selectedPairs,
      combined: iscombined,
      combinedSelectedPairs,
      allPairs
    })
  }

  renderFullView = type => {
    let {
      displayPairResults,
      displayResults,
      fullView,
      height
    } = this.state

    if (type === 'Main') {
      if (!fullView) {
        displayPairResults = 0
        displayResults = 12
        height = 600
      } else {
        displayPairResults = 5
        displayResults = 7
        height = 300
      }
    }
    if (type === 'Remote') {
      if (!fullView) {
        displayPairResults = 0
        displayResults = 0
        height = 600
      } else {
        displayPairResults = 5
        displayResults = 7
        height = 300
      }
    }

    this.setState({ 
      displayPairResults,
      displayResults,
      height,
      fullView: !fullView
    })
  }

  handlePairsSelection = e => {
    let {
      selectedPairs,
      combined,
      combinedSelectedPairs,
      allPairs
    } = this.state
    let all = false
    if (e.target.value[1] === 'all') {
      selectedPairs = selectedPairs.map((pair, key) => {
        return { ...pair, ...{ checked: !allPairs } }
      })
      if (combined) {
        combinedSelectedPairs = combinedSelectedPairs.map((pair, key) => {
          return { ...pair, ...{ checked: !allPairs } }
        })
      }
      this.setState({
        allPairs: !allPairs,
        selectedPairs,
        combinedSelectedPairs
      })
    } else {
      let selected = selectedPairs.findIndex(x => x.key === e.target.value[1])
      selectedPairs[selected].checked = !selectedPairs[selected].checked
      all = selectedPairs.findIndex(x => x.checked === false) === -1
      let selectedCombined
      if (combined) {
        selectedCombined = combined
          ? combinedSelectedPairs.findIndex(x => x.key === e.target.value[1])
          : null
        combinedSelectedPairs[selected].checked = !combinedSelectedPairs[
          selected
        ].checked
      }
      this.setState({
        allPairs: all,
        selectedPairs,
        combinedSelectedPairs
      })
    }
  }

  render() {
    const {
      classes,
      translate,
      subtestSignaltekResults,
      chartLineStyle,
      chartMeasurement,
      showMargin,
      subtest
    } = this.props

    const {
      displayPairResults,
      displayResults,
      selectedPairs,
      combinedSelectedPairs,
      allPairs,
      fullView,
      combined,
      height
    } = this.state

    return subtestSignaltekResults && subtestSignaltekResults.qualificationrfdata && subtestSignaltekResults.qualificationrfdata.subtesttype === subtest ? (
      <div ref='container'>
        <Paper className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
            <PairSelector
              handlePairsSelection={this.handlePairsSelection}
              selectedPairs={selectedPairs}
              combinedSelectedPairs={combinedSelectedPairs}
              allPairs={allPairs}
              combined={combined}
              translate={translate}
            />
          </Grid>
          {subtestSignaltekResults.qualificationrfdata &&
            <Grid container spacing={24}>
              {displayPairResults !== 0 &&
                <Grid
                  item
                  xs={displayPairResults}
                  sm={displayPairResults}
                  md={displayPairResults}
                  lg={displayPairResults}
                  xl={displayPairResults}
                >
                  <PairResultsViewer
                    data={subtestSignaltekResults.qualificationrfdata.pairdetails}
                    translate={translate}
                  />
                </Grid>}
              {displayResults !== 0 &&
                <Grid
                  className={classes.graph}
                  item
                  xs={displayResults}
                  sm={displayResults}
                  md={displayResults}
                  lg={displayResults}
                  xl={displayResults}
                >
                  <LineChartViewer
                    translate={translate}
                    pairs={subtestSignaltekResults.qualificationrfdata.pairs}
                    data={subtestSignaltekResults.qualificationrfdata.data}
                    type={translate('results_chart_display')}
                    graphType="Main"
                    renderFullView={this.renderFullView}
                    height={height}
                    selectedPairs={selectedPairs}
                    chartLineStyle={chartLineStyle}
                    chartMeasurement={chartMeasurement}
                    showMargin={showMargin}
                    fullView={fullView}
                    combined={combined}
                    combinedSelectedPairs={combinedSelectedPairs}
                    subtest={subtest}
                    CustomTooltip={<CustomTooltip />}
                  />
                </Grid>}
            </Grid>}
        </Paper>

      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }

  componentWillMount() {
    const { getSubtestResults, subtest, pager } = this.props;
    this.resetCurrentState();
    setTimeout(() => {
      getSubtestResults(pager.jid, pager.tid, subtest, null);
    }, 100);
  }
  componentWillReceiveProps(nextProps) {
    const { getSubtestResults, subtest, pager, subtestSignaltekResults } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      this.resetCurrentState();
      setTimeout(() => {
        getSubtestResults(pager.jid, pager.tid, subtest, null);
      }, 100);
      return;
    }
    if (
      subtestSignaltekResults &&
      subtestSignaltekResults.qualificationrfdata &&
      subtestSignaltekResults.qualificationrfdata.pairs
    ) {
      this.updatePairsInfo(subtestSignaltekResults.qualificationrfdata.pairs, false);
    }
  }
}

export default withStyles(styles)(QtRfResult)
